import {
  Button,
  MenuItem,
  ListItemIcon,
  Box,
  Badge,
  // Typography,
  // Stack,
} from "@mui/material";

import {
  ArrowDropDown,
  // ArrowDropUp,
  MenuBook,
  Book,
  NewReleases,
} from "@mui/icons-material";
import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { MANUAL_PATH_LIST } from "utility/constants";

import ReactGA from "react-ga4";
import { checkLanguage } from "utility";
import { WhatIsNewFullScreen } from "sections/whatIsNew";
import { ButtonNavbar, Menu } from "./MenuService";


const MenuHelp = () => {
  // const IS_FRIST_NAVBAR_HELP = "2.5.0";
  const { i18n, t } = useTranslation();
  // const { getDialog, onClose } = useDialog();
  const [openNewFeature, setOpenNewFeature] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const popoverRef = useRef(null);
  const handleClick = () => {
    setAnchorEl(popoverRef.current);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // HighLight new feature

  // const [isHighlight, setIsHighlight] = useState(false);
  // const onHighlightElement = () => {
  //   setIsHighlight(true);
  // };
  // const onRemoveHighlightElement = () => {
  //   setIsHighlight(false);
  //   store.set("isFrist", {
  //     ...store.get("isFrist"),
  //     newFeature: {
  //       navbarHelp: IS_FRIST_NAVBAR_HELP,
  //     },
  //   });
  // };

  return (
    <>
      <Box
        ref={popoverRef}
        onMouseEnter={handleClick}
        onMouseLeave={handleClose}
        id="box-button-menu-help"
      >
        <ButtonNavbar
          id="button-navbar-help"
          startIcon={<MenuBook />}
          endIcon={<ArrowDropDown />}
          onClick={handleClick}
          sx={
            {
              // ...(isHighlight && {
              //   backgroundColor: "#ffffff",
              //   zIndex: 2,
              // }),
            }
          }
        >
          {t("appbar.help")}
        </ButtonNavbar>
      </Box>
      <Menu
        id="basic-menu-1"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableAutoFocus
        sx={{
          pointerEvents: "none",
        }}
        PaperProps={{
          onMouseEnter: handleClick,
          onMouseLeave: handleClose,
          sx: {
            pointerEvents: "auto",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            ReactGA.event("click_navigation", {
              component: "navbar",
              link: "manual",
            });
          }}
          component={Button}
          href={MANUAL_PATH_LIST[checkLanguage(i18n.language) === "th" ? "th" : "en"]}
          target="_blank"
        >
          <ListItemIcon>
            <Book fontSize="small" color="primary" />
          </ListItemIcon>

          <Box sx={{ pr: 0.5 }}>{t("appbar.help_manual")}</Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            setOpenNewFeature(true);
            ReactGA.event("click_navigation", {
              component: "navbar",
              link: "new feature",
            });
          }}
        >
          <ListItemIcon>
            <NewReleases fontSize="small" color="primary" />
          </ListItemIcon>
          <Badge
            badgeContent={" "}
            variant="dot"
            color="warning"
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Box sx={{ pr: 0.5 }}>{t("appbar.help_new_feature")}</Box>
          </Badge>
        </MenuItem>
      </Menu>

      {/* HighLight new feature */}
      {/* {isHighlight && <div className={"overlay"} />}
      <Menu
        id="popover-new-feature-navbar-help"
        open={isHighlight}
        anchorEl={document.getElementById("button-navbar-help")}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box
          sx={{
            color: "primary.main",
            mt: 1.5,
            mb: 1.5,
            ml: 2,
            mr: 2,
            fontSize: "16px",
            fontWeight: 600,
            maxWidth: "290px",
          }}
        >
          <Typography>{t("overlay_new_feature.0.title")}</Typography>
          <Stack direction={"row-reverse"} sx={{ mt: 1 }}>
            <Typography
              onClick={() => {
                onRemoveHighlightElement();
                setOpenNewFeature(true);
              }}
              sx={{ textDecoration: "underline", cursor: "pointer" }}
            >
              {t("got it")}
            </Typography>
          </Stack>
        </Box>
      </Menu> */}
      {/* ----------- */}
      {openNewFeature && (
        <WhatIsNewFullScreen open={openNewFeature} handleClose={()=>setOpenNewFeature(false)} />
      )}
    </>
  );
};

export default MenuHelp;
